<template>
  <v-layout>
    <v-app-bar
        app
        dark
        color="secondary"
    >
      <v-progress-linear
          :indeterminate="loading"
          fixed
          top
      ></v-progress-linear>
      <v-btn
          icon
          to="/applications/"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>Application</v-toolbar-title>
    </v-app-bar>
    <v-main class="pt-12">
      <v-dialog
          v-model="loading"
          persistent
          width="300"
      >
        <v-card
            color="primary"
            dark
        >
          <v-card-text class="py-2 text-center">
            <span>Uploading application data</span><br><span class="font-weight-bold">Please wait...</span>
            <v-progress-linear
                :indeterminate="indeterminate"
                :value="progress"
                color="white"
                class="mb-0 mt-2"
            ></v-progress-linear>
            <span class="text--white d-inline-block pt-2 font-italic">Do not refresh page or press something</span>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-row>
        <v-col col="12">
          <v-card>
            <v-card-text>
              <v-form v-model="valid" ref="form">
                <v-radio-group
                    v-model="option"
                    :rules="rules.option"
                    row
                    required
                >
                  <template v-slot:label>
                    <div>Application option:</div>
                  </template>
                  <v-radio v-for="opt in options" :key="opt.value" :label="opt.display_name"
                           :value="opt.value"></v-radio>
                </v-radio-group>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
            v-for="(applicant, i) in applicants"
            :key="i"
            cols="12" md="6" lg="4"
        >
          <applicant-card
              v-model="applicants[i]"
              :mainApplicant="i === 0"
              @remove="removeApplicant(i)"
              ref="applicants"
          ></applicant-card>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <v-card
              outlined
              class="py-12 px-12 text-center"
          >
            <v-card-text>
              <v-btn
                  rounded
                  x-large
                  color="secondary"
                  @click.prevent="addApplicant"
                  :disabled="loading"
              >
                <v-icon left>mdi-account-plus</v-icon>
                Add Applicant
              </v-btn>
              <v-sheet class="grey lighten-5 my-3 py-3">
                <p class="grey--text text--darken-2 text-center display-1 pa-0 ma-0 font-weight-bold">OR</p>
                <p class="grey--text text--darken-2 text-center headline pa-0 ma-0 font-weight-light">if no other
                  applicants</p>
              </v-sheet>
              <v-btn
                  rounded
                  x-large
                  color="secondary"
                  @click.prevent="save"
                  :disabled="loading"
              >
                <v-icon left>mdi-check</v-icon>
                Submit Application
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <confirm ref="confirmRestore"></confirm>
    </v-main>
  </v-layout>
</template>
<script>
import ApplicantCard from './Applicants/Card'
import Confirm from '@/components/App/Confirm'
import {createApplicant} from './const'
import {errorNotification, getResponseError} from "@/components/utils"
import store from "@/store"


export default {
  components: {
    ApplicantCard,
    Confirm
  },
  name: 'ApplicationCreate',
  data() {
    return {
      applicants: [],
      loading: false,
      indeterminate: true,
      progress: 0,
      options: [],
      option: null,
      rules: {
        option: [
          v => !!v || 'Option is required',
        ],
      },
      valid: false
    }
  },
  methods: {
    fetchOptions() {
      // Fetch possible options
      this.$axios.options('/applications/')
          .then((response) => {
            let data = response.data
            this.options = data.actions.POST.option.choices
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    addApplicant(details = null) {
      this.applicants.push(new createApplicant(details))
    },
    removeApplicant(index) {
      this.applicants.splice(index, 1)
    },
    validate() {
      let validation = []
      if (!this.$refs.form.validate()) {
        return false
      }
      this.$refs.applicants.forEach((applicant) => {
        validation.push(applicant.validate())
      })
      return validation.every(i => i)
    },
    checkAuthSession() {
      return new Promise((resolve, reject) => {
        if (this.$store.getters['auth/isExpired']()) {
          store.dispatch('auth/refresh')
              .then(() => {
                resolve()
              })
              .catch((e) => {
                // store.dispatch('auth/logout')
                reject(getResponseError(e))
              })
        } else {
          resolve()
        }
      })
    },
    save() {
      let excluded_fields = ['passport', 'birthcertificate']
      // Save backup data in localstorage
      localStorage.setItem('applicationDataBackup', JSON.stringify(
          {
            option: this.option,
            applicants: this.applicants.map((a) => {
              return Object.keys(a).filter(objKey => {
                return !excluded_fields.includes(objKey)
              }).reduce((newObj, key) => {
                    newObj[key] = a[key]
                    return newObj
                  }, {}
              )
            })
          }
      ))
      if (this.applicants.length && this.validate()) {
        this.checkAuthSession()
            .then(() => {
              this.loading = true
              let data = new FormData()
              data.append('option', this.option)
              this.applicants.forEach((applicant, index) => {
                data.append('applicants[' + index + '][is_main]', index <= 0)
                for (let key in applicant) {
                  if (key === 'isTrusted') {
                    continue
                  }
                  if (!(excluded_fields.includes(key) && applicant[key] === null)) {
                    data.append('applicants[' + index + '][' + key + ']', applicant[key])
                  }
                }
              })
              // Create Application
              this.$axios.post('/applications/', data, {
                onUploadProgress: (event) => {
                  if (event.lengthComputable && event.loaded < event.total) {
                    this.indeterminate = false
                    this.progress = event.loaded * 100 / event.total
                  } else {
                    this.indeterminate = true
                    this.progress = 0
                  }
                }
              })
                  .then((response) => {
                    let number = response.data.number
                    let id = response.data.id
                    // Remove localstorage data backup
                    if (localStorage.getItem('applicationDataBackup')) {
                      localStorage.removeItem('applicationDataBackup')
                    }
                    this.$store.dispatch('snackbar/info', 'Application created #' + number)
                    this.loading = false
                    this.$router.push({name: 'ApplicationView', params: {id: id}})
                  })
                  .catch((error) => {
                    errorNotification(error)
                  })
                  .finally(() => {
                    this.loading = false
                  })
            })
            .catch((error) => {
              errorNotification(error)
            })
      }
    }
  },
  mounted() {
    this.confirmRestore = this.$refs.confirmRestore.open
    this.fetchOptions()
    // Load backup data if there is any
    let applicationDataBackup = JSON.parse(localStorage.getItem('applicationDataBackup')) || null
    if (applicationDataBackup) {
      this.confirmRestore('Restore Backup', 'Recovered data from an incomplete application was found. Would you like to use it? You will still need to reattach the files.', {color: 'primary'}).then((confirm) => {
        if (confirm) {
          this.option = applicationDataBackup.option
          for (const applicant in applicationDataBackup.applicants) {
            this.addApplicant(applicationDataBackup.applicants[applicant])
          }
          localStorage.removeItem('applicationDataBackup')
        } else {
          localStorage.removeItem('applicationDataBackup')
        }
      })
    }
  }
}
</script>